export const DEFAULT_VIEW = "DEFAULT_VIEW";
export const DRAFT_VIEW = "DRAFT_VIEW";
export const MESSAGE_VIEW = "MESSAGE_VIEW";
